import React, { useEffect } from "react";
import { FormProvider } from "react-hook-form";
import { Loader } from "semantic-ui-react";
import useAgeVerification from "@common/components/hooks/useAgeVerification";
import AgeVerificationForm from "@common/components/shared/AgeVerification/AgeVerificationForm";
import LoginAction from "@common/redux/actions/LoginAction";
import useEventDetailsGrid from "@hooks/useEventDetailsGrid";
import AgeVerificationClient from "@common/api/AgeVerificationClient";
import { parseAgeVerificationResponse } from "@common/components/helpers/compliance.js";
import ComplianceHeader from "../ComplianceHeader.js";
import { handleError } from "@common/components/helpers/error";
import useComplianceView from "../../../hooks/useComplianceView.js";

const AgeVerificationContainer = () => {
  const {
    methods,
    methods: { reset },
  } = useAgeVerification();
  const {
    activeRow: {
      event: { id },
    },
  } = useEventDetailsGrid();
  const { formLoading, setViewData } = useComplianceView();

  const loadRecord = (isRead = true) => {
    if (!id) {
      return;
    }

    setViewData({ formLoading: true });
    const fnRead = isRead
      ? AgeVerificationClient.Read
      : AgeVerificationClient.ReadForUpdate;

    fnRead(id)
      .then(({ record }) => {
        const {
          site: { guid },
        } = record;
        LoginAction.dispatch({ siteGuid: guid, isInReadMode: isRead });
        reset(parseAgeVerificationResponse(record));
      }, handleError)
      .finally(() => setViewData({ formLoading: false }));
  };

  useEffect(loadRecord, [id]);

  if (formLoading) {
    return <Loader active />;
  }

  return (
    <FormProvider {...methods}>
      <ComplianceHeader title="Age Verification" loadRecord={loadRecord} />
      <AgeVerificationForm />
    </FormProvider>
  );
};

export default AgeVerificationContainer;
